import {useStoreService} from '../../service/store/index'
import { IStore } from "../../utils/interfaces/IStore";

const useUpdateStore = () => {
    const {updateStore} = useStoreService()
  const updateStoreHooks = async (data: IStore) => {
     await updateStore(data)
  };
  return {
    updateStoreHooks,
  };
};

export default useUpdateStore;
